module.exports = __webpack_public_path__ + "static/media/example-2.44016f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/VanMasters/example-2.jpg
// module id = 258
// module chunks = 0